<template>
  <ckeditor
    v-model="editorData"
    :config="editorConfig"
    :editor="editor"
    :disabled="editorDisabled"
    @ready="onEditorReady"
    @focus="onEditorFocus"
    @blur="onEditorBlur"
    @input="onEditorInput"
    @destroy="onEditorDestroy"
  ></ckeditor>
</template>

<script>
import CKEditor from '@ckeditor/ckeditor5-vue2';
import IpscapeEditor from '@ipscape/ckeditor5-build';

export default {
  name: 'IpsEditor',
  components: {
    ckeditor: CKEditor.component,
  },
  props: {
    value: {
      name: 'value',
      description: 'The content of the editor',
      type: String,
      default: '',
      required: false,
    },
    editorConfig: {
      name: 'editorConfig',
      description: 'Editor config',
      type: Object,
      default() {
        return {};
      },
      required: false,
    },
    dynamicFields: {
      name: 'dynamicFields',
      description: 'Dynamic fields',
      type: Array,
      default() {
        return [];
      },
      required: false,
    },
    systemVariables: {
      name: 'systemVariables',
      description: 'System variables',
      type: Array,
      default() {
        return [];
      },
      required: false,
    },
  },
  data() {
    return {
      editor: IpscapeEditor,
      editorData: '',
      editorDisabled: false,
      editorInstance: null,
    };
  },
  watch: {
    value(newValue) {
      this.editorData = newValue;
    },
  },
  created() {
    window.addEventListener('on-editor-ips-attach-image', this.emitImageAttachEvent);
    window.addEventListener('on-editor-ips-insert-image', this.emitImageInsertEvent);
    window.addEventListener('on-editor-ips-select-files', this.emitFilesSelectEvent);
  },
  destroyed() {
    window.removeEventListener('on-editor-ips-attach-image', this.emitImageAttachEvent);
    window.removeEventListener('on-editor-ips-insert-image', this.emitImageInsertEvent);
    window.removeEventListener('on-editor-ips-select-files', this.emitFilesSelectEvent);
  },
  methods: {
    onEditorReady(editor) {
      this.$emit('on-editor-ready', editor);
    },
    onEditorFocus(event, editor) {
      this.$emit('on-editor-focus', editor);
    },
    onEditorBlur(event, editor) {
      this.$emit('on-editor-blur', editor);
    },
    onEditorInput(data, event, editor) {
      this.$emit('on-editor-input', editor);
    },
    onEditorDestroy(editor) {
      this.$emit('on-editor-destroy', editor);
    },
    emitImageAttachEvent() {
      this.$emit('on-editor-ips-attach-image');
    },
    emitImageInsertEvent() {
      this.$emit('on-editor-ips-insert-image');
    },
    emitFilesSelectEvent(event) {
      this.$emit('on-editor-ips-select-files', event.detail);
    },
  },
};
</script>
